// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"dac4869d","1141":"9524635b","1510":"dd77402c","2099":"2ba9f4e7","4429":"c8b29b24","4517":"b40eb912","4965":"9e9329f4","5841":"2ba9f4e7","6122":"57f95a1a","7926":"0eecf8c1","8231":"df742b0f"}[chunkId] + ".chunk.css";
};